import { colors } from "./colors";

/** ประเภทผู้ทำการแทน — ต้องตรงกับ enum CUSTOMER_AGENT_TYPE ฝั่ง backend */
export enum CUSTOMER_AGENT_TYPE {
  PAYER = "PAYER",
  HEIR = "HEIR",
  ALL = "ALL",
}

/** value ที่ส่ง/รับกับ API -> label ที่โชว์บนหน้าจอ */
export const CUSTOMER_AGENT_TYPE_LABEL: Record<string, string> = {
  [CUSTOMER_AGENT_TYPE.PAYER]: "ผู้ชำระเงินแทน",
  [CUSTOMER_AGENT_TYPE.HEIR]: "ผู้รับมรดก",
  [CUSTOMER_AGENT_TYPE.ALL]: "ทั้งหมด",
};

/** สีของ badge ต่อประเภท (ใช้ palette เดิมจาก constants/colors) */
export const CUSTOMER_AGENT_TYPE_COLOR: Record<string, string> = {
  [CUSTOMER_AGENT_TYPE.PAYER]: colors.green,
  [CUSTOMER_AGENT_TYPE.HEIR]: colors.themeSecondColor,
  [CUSTOMER_AGENT_TYPE.ALL]: colors.gray,
};

/** ลำดับที่ใช้ render dropdown */
export const CUSTOMER_AGENT_TYPE_OPTIONS: CUSTOMER_AGENT_TYPE[] = [
  CUSTOMER_AGENT_TYPE.PAYER,
  CUSTOMER_AGENT_TYPE.HEIR,
  CUSTOMER_AGENT_TYPE.ALL,
];

export const customerAgentTypeLabel = (type?: string) =>
  (type && CUSTOMER_AGENT_TYPE_LABEL[type]) || "-";

export const customerAgentTypeColor = (type?: string) =>
  (type && CUSTOMER_AGENT_TYPE_COLOR[type]) || colors.gray;

/** สถานะผู้รับมรดก (heir_status) — null เมื่อไม่ใช่ผู้รับมรดก */
export enum HEIR_STATUS {
  /** ยังไม่รับเอกสาร ใช้งานได้ถึงวันก่อน heir_expire_date */
  ACTIVE = "ACTIVE",
  /** ยังไม่รับเอกสาร และหมดอายุแล้ว */
  EXPIRED = "EXPIRED",
  /** รับเอกสารแล้ว ใช้งานได้ถาวร */
  DOC_RECEIVED = "DOC_RECEIVED",
}

/** ปุ่ม ต่ออายุ / รับเอกสาร กดได้เฉพาะ ACTIVE กับ EXPIRED (ค่าอื่น backend ตอบ 400) */
export const canManageHeir = (status?: string | null) =>
  status === HEIR_STATUS.ACTIVE || status === HEIR_STATUS.EXPIRED;
